export default __webpack_public_path__ + "static/media/Gruesome_1.0dc9254a.jpg";